import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TextMarketingPageRoutingModule } from './text-marketing-routing.module';

import { TextMarketingPage } from './text-marketing.page';

import { TextMarketingComposerComponentModule } from './marketing-composer/marketing-composer.module';
import { TextMarketingHistoryListComponentModule } from './marketing-history-list/marketing-history-list.module';
import { MenuButtonComponentModule } from '../components/smr-menu-button/smr-menu-button.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TextMarketingPageRoutingModule,
    TextMarketingComposerComponentModule,
    TextMarketingHistoryListComponentModule,
    MenuButtonComponentModule
  ],
  declarations: [TextMarketingPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TextMarketingPageModule {}
